import React from "react"

import { JsonContentMarkup } from "../../../shared-components/seo/json-content-markup"

type Props = {
  headline: string
  image: string
  datePublished: string
  dateModified?: string
  authorNames: Array<string>
}

export const ArticleJsonMd = ({
  headline,
  image,
  datePublished,
  dateModified,
  authorNames,
}: Props) => {
  return (
    <JsonContentMarkup
      content={{
        "@type": "BlogPosting",
        headline,
        image,
        datePublished,
        dateModified,
        author: authorNames?.map(name => ({
          "@type": "Person",
          name,
        })),
      }}
    />
  )
}
